<script setup lang="ts">
import { useResetPasswordSchema } from '@layers/common/app/schemas'
import { requestPasswordReset } from '@layers/common/app/services/auth'
import { useForm } from 'vee-validate'

const { t } = useI18n()
const localePath = useLocalePath()
const { toast } = useToast()

const alert = ref('')
const { isSubmitting, handleSubmit } = useForm({
  validationSchema: useResetPasswordSchema(),
})

const onSubmit = handleSubmit(async (values) => {
  alert.value = ''

  try {
    await requestPasswordReset(values)

    toast({
      title: t('auth.reset_password.success'),
      variant: 'success',
    })

    return navigateTo(localePath('/'))
  }
  catch (err) {
    if (err instanceof Error) {
      alert.value = err.message
    }
    else {
      alert.value = t('validation.unknown.message')
    }

    console.error(err)
  }
})
</script>

<template>
  <form @submit="onSubmit">
    <UiAlert v-if="alert" variant="destructive">
      <Icon name="heroicons:exclamation-circle" class="h-4 w-4" mode="svg" />
      <UiAlertTitle>{{ alert }}</UiAlertTitle>
    </UiAlert>

    <UiFormField v-slot="{ componentField }" name="emailAddress" :validate-on-model-update="false">
      <UiFormItem v-auto-animate>
        <UiFormLabel>{{ t('form.email_address.label') }}</UiFormLabel>
        <UiFormControl>
          <UiInput type="email" autocomplete="username" v-bind="componentField" data-testid="resetPassword-emailAddress" />
        </UiFormControl>
        <UiFormMessage />
      </UiFormItem>
    </UiFormField>

    <div>
      <UiButton
        data-testid="resetPassword-submit"
        type="submit"
        class="w-full"
        :loading="isSubmitting"
        variant="orange"
      >
        <Icon v-if="isSubmitting" name="lucide:loader-circle" class="size-4 animate-spin" />
        {{ t('reset_password.form.submit') }}
      </UiButton>
    </div>
  </form>
</template>
